import LegalPage from '../shared/LegalPage';
import { business } from '../content';
import { useLanguage } from '../language/LanguageContext';
import { fillTemplate } from '../language/translations';

function Support() {
  const { t } = useLanguage();
  const values = {
    appName: business.appName,
    email: business.supportEmail
  };

  return (
    <LegalPage
      title={t.support.title}
      intro={fillTemplate(t.support.intro, values)}
    >
      <section className="support-box">
        <h2>{t.support.contactTitle}</h2>
        <p>
          {fillTemplate(t.support.contactText, values).split(business.supportEmail)[0]}
          <a href={`mailto:${business.supportEmail}`}>{business.supportEmail}</a>
          {fillTemplate(t.support.contactText, values).split(business.supportEmail)[1]}
        </p>
        <a className="button primary" href={`mailto:${business.supportEmail}`}>
          {t.support.emailCta}
        </a>
      </section>

      <section>
        <h2>{t.support.responseTitle}</h2>
        <p>{t.support.responseText}</p>
      </section>

      <section>
        <h2>{t.support.detailsTitle}</h2>
        <ul>
          {t.support.details.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>
    </LegalPage>
  );
}

export default Support;
